import {ClassNameProps} from '@app/helpers/react';
import styled, {keyframes} from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(1turn);
  }
`;

const UnstyledSpinner = ({className}: ClassNameProps) => (
  <svg viewBox="0 0 100 100" className={className}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="20"
      d="M 90 50 A 10 10 0 0 0 10 50"
    ></path>
  </svg>
);

const Spinner = styled(UnstyledSpinner)`
  vertical-align: middle;
  display: inline-block;
  animation: ${spin} 1.2s ease infinite;
  overflow: visible !important;
  height: var(--icon-default-size, calc(24 / 14 * 1em));
`;

export default Spinner;
